/* eslint-disable import/prefer-default-export */
/**
 * @readonly
 * @enum {string}
 */
export const YAxisGroup = Object.freeze({
  SW_BUZZ: 'SW_BUZZ',
  SW_BUZZ_POST: 'SW_BUZZ_POST',
  SW_SENTIMENT: 'SW_SENTIMENT',
  SW_CALCULATED_SENTIMENT: 'SW_CALCULATED_SENTIMENT',
  SW_CALCULATED_SCORES: 'SW_CALCULATED_SCORES',
  SW_NET_PROMOTER_SCORES: 'SW_NET_PROMOTER_SCORES',
  SW_IMPRESSION: 'SW_IMPRESSION',
  SW_ENGAGEMENTS: 'SW_ENGAGEMENTS',
  SW_ENGAGEMENT_RATIO: 'SW_ENGAGEMENT_RATIO',
  UNIQUE_AUTHORS: 'UNIQUE_AUTHORS',
  STATISTICS: 'STATISTICS',
  NONE: 'NONE'
})

export type YAxisGroupStrings = typeof YAxisGroup[keyof typeof YAxisGroup]

/**
 * @const
 * @enum {string}
 */
export const SeriesType = Object.freeze({
  LINE: 'line',
  COLUMN: 'column',
  AREASPLINE: 'areaspline',
  SPLINE: 'spline',
  FLAGS: 'flags',
  AREA: 'area'
})

export type SeriesTypeStrings = typeof SeriesType[keyof typeof SeriesType]

export type TimeUnit =
  | 'millisecond'
  | 'second'
  | 'minute'
  | 'hour'
  | 'day'
  | 'week'
  | 'month'
  | 'year'

export type Coordinate = {
  x: number
  y?: number
}
